import React from "react";
import { cn } from "../utils";
import { typography } from "../tokens";

export function DataTable({ children, className }) {
  return <table className={cn("w-full", className)}>{children}</table>;
}

export function DataTableHead({ children }) {
  return (
    <thead>
      <tr className="bg-gray-50/70 border-b border-gray-100/60">{children}</tr>
    </thead>
  );
}

export function DataTableHeadCell({ children, className }) {
  return (
    <th
      className={cn("text-left px-4 py-3 text-gray-500 whitespace-nowrap", className)}
      style={{ fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}
    >
      {children}
    </th>
  );
}

export function DataTableBody({ children }) {
  return <tbody className="divide-y divide-gray-100/40">{children}</tbody>;
}

export function DataTableRow({ children, className, ...props }) {
  return <tr className={cn("hover:bg-gray-50/60 transition-colors group", className)} {...props}>{children}</tr>;
}

export function DataTableCell({ children, className }) {
  return <td className={cn("px-4 py-3.5", className)}>{children}</td>;
}

export function StatusBadge({ bg, text, icon: Icon, children, className }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full", bg, text, className)} style={typography.badge}>
      {Icon && <Icon className="w-3 h-3" />}
      {children}
    </span>
  );
}

export function TagBadge({ children, className }) {
  return (
    <span className={cn("px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-nowrap", className)} style={typography.badge}>
      {children}
    </span>
  );
}

export function ProgressBar({ value, colorClass = "bg-blue-500", width = "w-20", showLabel = true }) {
  return (
    <div className="flex items-center gap-2">
      <div className={cn(width, "h-1.5 bg-gray-100 rounded-full overflow-hidden")}>
        <div className={cn("h-full rounded-full", colorClass)} style={{ width: `${value}%` }} />
      </div>
      {showLabel && <span className="text-gray-500" style={{ fontSize: "0.75rem" }}>{value}%</span>}
    </div>
  );
}
